import createCache from '@emotion/cache'

// This function creates a new emotion cache instance. We use the 'css' key
// and prepend: true so that MUI styles have the proper priority.
export default function createEmotionCache() {
  return createCache({ key: 'css', prepend: true })
}
